import SwCacheService from 'app/services/swCache.service';
import NetworkConnectionActionsService, {STATUS_CHANGE} from "app/actions/networkConnection.actions";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import {CouchStatus} from "app/app.types";
import TelemetryService from "app/services/telemetry/telemetry.service";
import PouchLoadService from "external-services/pouch-load-service/index";
import TrackingService from "app/services/tracking/tracking.service";

// requiring html templates so that hot reloading works
const template = require('./statusInfo.html');

const NS = 'StatusInfo'; // jshint ignore:line

export default function StatusInfo() { // as statusInfo
  "ngInject";

  return {
    restrict: 'E',
    replace: true,
    controller,
    controllerAs: 'statusInfo',
    template
  };

  function controller(
    $scope, $rootScope, $timeout,
    pouchService, unregister, appConstants
  ) {
    "ngInject";

    const vm = this;

    const LOAD_STATUS_TYPES = {
      IDLE: 1,
      CLEARING_CACHES: 2,
      READY_TO_RELOAD: 3
    };

    vm.LOAD_STATUS_TYPES = LOAD_STATUS_TYPES;
    vm.loadStatus = LOAD_STATUS_TYPES.IDLE;

    vm.TelemetryService = TelemetryService;
    vm.title = null;
    vm.msg = null;
    vm.statusIcon = '';
    vm.statistics = null;
    vm.loadingStatistics = false;

    vm.offline = {
      ready: true,
      heading: 'Offline mode',
      msg: 'App is ready to be used in offline mode',
      reason: ''
    };

    vm.refreshCache = function() {
      vm.loadStatus = LOAD_STATUS_TYPES.CLEARING_CACHES;
      vm.offline.msg = `Clearing old caches...`;

      SwCacheService.deleteCache(error1 => {
        SwCacheService.cacheUnregister(error2 => {
          /**
           * If the cache doesn't exist or fails, still do the reload.
           */
          // vm.loadStatus = LOAD_STATUS_TYPES.READY_TO_RELOAD;
          vm.offline.heading = 'Offline mode';
          vm.offline.msg = `Loading new version...`;
          // vm.offline.ready = true;

          // timeout just gives browser a chance full clear cache before reloading
          setTimeout(() => window.location.reload(), 5000);
        });
      });
    };

    $timeout(() => {
      SwCacheService.checkCache()
        .then(isCached => {
          // local dev will likely be using flag `--skipCache true`, which disables offline caching, so we should ignore this if local
          isCached = isCached || appConstants.Environment.IsLocal;

          vm.offline.ready = isCached;

          if (!isCached) {
            vm.offline.heading = 'Offline mode disabled!';
            vm.offline.msg = `App is not ready for offline mode!
              This can happen if you have cleared the browser's cache.`;
          }

          NetworkConnectionService.setOfflineDisabled(!isCached);
          NetworkConnectionActionsService.statusChange();
        });
    }, 5000); // using delay because it may take awhile for the cache to install

    vm.updateStatistics = updateStatistics;

    const listeners = [];
    listeners.push($rootScope.$on(STATUS_CHANGE, () => {
      statusUpdate();
    }));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    statusUpdate();

    function setStatusInfo() {
      let title = 'Online';
      let msg = 'You are currently online, all changes will be synced.';
      vm.offline.reason = '';

      if (NetworkConnectionService.isOnline()) {
        switch (NetworkConnectionService.getCouchStatusConnection()) {
          case CouchStatus.receiving:
            title = 'Receiving';
            msg = 'You are currently online and new changes are being downloaded from the server.';
            break;
          case CouchStatus.sending:
            title = 'Sending';
            msg = 'You are currently online and your changes are being uploaded to the server.';
            break;
        }

        TrackingService.trackOfflineStatus();
      } else {
        title = 'Offline';
        msg = "You are currently offline and changes you make won't be synced. Please go back online.";
        const offlineReasons = NetworkConnectionService.whyOfflineMessage();
        vm.offline.reason = offlineReasons.join('<br>');

        TrackingService.storeOfflineStatus(offlineReasons);
      }

      vm.title = title;
      vm.msg = msg;
    }

    function statusUpdate() {
      vm.statusIcon = NetworkConnectionService.getNetworkConnectionIconName();
      setStatusInfo();
    }

    function updateStatistics() {
      vm.statistics = null;
      vm.loadingStatistics = true;

      // Compute statistics
      const reduceFunction = {
        map: function (doc) {
          emit(doc.type);
        },
        reduce: '_count',
      };
      PouchLoadService.selectDatabase().query(reduceFunction, {
        reduce: true,
        group: true
      }).then(function (result) {
        vm.statistics = result;
        vm.loadingStatistics = false;
      }).catch(function (err) {
        console.error('Error counting documents in local PouchDB', err);
        vm.loadingStatistics = false;
      });
    }

  }
}

